import { render, staticRenderFns } from "./CompanyCounts.vue?vue&type=template&id=31e2bd99"
import script from "./CompanyCounts.vue?vue&type=script&lang=js"
export * from "./CompanyCounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports